/**
 * @namespace SocialMediaShare
 */
class SocialMediaShare {
    constructor() {

    }

    getFacebookShareHREF(URL) {
        return `https://www.facebook.com/sharer/sharer.php?u=${URL}`;
    }

    getTwitterShareHREF(URL, text = "") {
        return `https://twitter.com/intent/tweet?text=${text} ${URL}`;
    }

    getPinterestShareHREF(URL, description = "", imgPath = "") {
        if (!imgPath && !description) {
            return `http://pinterest.com/pin/create/button/?url=${URL}`
        }
        if (imgPath && !description) {
            return `http://pinterest.com/pin/create/button/?url=${URL}&media=${imgPath}`
        }
        else {
            return `http://pinterest.com/pin/create/button/?url=${URL}&media=${imgPath}&description=${description}`;
        }
    }

    getEmailShareHREF(URL, description = "") {
        if(!description) {
            return `mailto:?body=${URL}`;
        } else {
            return `mailto:?subject=${description}&body=${URL}`;
        }
    }

    getShareHREF(URL, platform, contentOrDescription, imagePath) {
        return platform === 'facebook' ? this.getFacebookShareHREF(URL) :
            platform === 'pinterest' ? this.getPinterestShareHREF(URL, contentOrDescription, imagePath) :
                platform === 'twitter' ? this.getTwitterShareHREF(URL, contentOrDescription) :
                    platform === 'email' ? this.getEmailShareHREF(URL, contentOrDescription) : '';
    }
}

export default new SocialMediaShare();
